// extracted by mini-css-extract-plugin
export default {"contentInut":"MessageInput_contentInut__pfKES","commentInput":"MessageInput_commentInput__IBRj8","iconSend":"MessageInput_iconSend__ZjTNm"};